import ExpandingContainer from "./ExpandingContainer";

export default ExpandingContainer;
